import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box, HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Panel from "@ui/panel/Panel";
import Spacer from "@ui/spacer/Spacer";
import { usePresenter } from "badmfck-presenter";
import Signal from "badmfck-signal";

export const S_CHANGE_CLIENT_STATUS_POPUP = new Signal<{ id: number } | null>("S_CHANGE_CLIENT_STATUS_POPUP");

export const ClientStatusPopup = () => {
	useLocale();
	const requestData = S_CHANGE_CLIENT_STATUS_POPUP.use();
	const presenter = usePresenter();

	if (!requestData) return null;

	const closePopup = () => {
		S_CHANGE_CLIENT_STATUS_POPUP.invoke(null);
	};

	return (
		<Panel
			sx={{
				minWidth: "1000px",
				width: "85vw",
				height: "85vh",
				padding: "0",

				// minWidth: "500px",
			}}
			decorator="absolute"
			label={msg("title_5d106b1e")}
			onClose={closePopup}>
			{/* <VBox
				gap="20px"
				sx={{
					overflow: "auto",
					flexGrow: 1,
					padding: "20px 20px",
					backgroundColor: "#EEF0F2",
				}}></VBox> */}

			<Box
				sx={{
					overflow: "auto",
					width: "100%",
					paddingLeft: "20px",
					paddingRight: "20px",
				}}>{msg("noClinetRendered")}</Box>

			<Spacer grow />

			<VBox sx={{ padding: "20px", gap: "12px", width: "100%" }}>
				<HBox gap="12px" sx={{ width: "100%" }}>
					<Button
						sx={{ flex: 1 }}
						title={msg("clientPage")}
						onClick={() => {
							presenter.navChange("client", {
								cid: requestData.id,
							});
							closePopup();
						}}
					/>

					<Button
						sx={{ flex: 1 }}
						title={msg("close")}
						onClick={() => {
							closePopup();
						}}
					/>
				</HBox>
			</VBox>
		</Panel>
	);
};
